import { useState } from "react";
import "./input.scss";
import IconResource from "../../../Wrapper/IconResource/IconResource";
import { Form, InputGroup } from "react-bootstrap";
import CurrencyInput from 'react-currency-input-field';
import { preventPlusMinusInNumberInput } from "../../../Services/common";
import { DOLLAR, RUPEE } from "../../../Constants/storageConstant";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

const Input = (props) => {
  const [showPassword, setShowPassword] = useState(false);

  const { onClickIconPre, onClickIconSuff, isRequired, showLoaderIcon, value, onChange, placeholder, country, disabled = false, autoFocus = false } =
    props;

  const render = () => {
    switch (props?.inputType) {
      case "password":
        return (
          <>
            <Form.Label className={isRequired ? "is-required" : ""} aria-label="password">
              {props?.label ? props?.label : "Password"}
            </Form.Label>
            <InputGroup className="mb-3">
              <Form.Control
                autoComplete="false"
                pattern={props?.pattern}
                placeholder={
                  props?.placeholder
                    ? props?.placeholder
                    : "Enter your Password"
                }
                aria-label="password"
                aria-describedby="basic-addon2"
                type={showPassword ? "text" : "password"}
                {...props}
              />
              <InputGroup.Text
                id="basic-addon2"
                onClick={() => {
                  setShowPassword((prev) => !prev);
                }}
                style={{ cursor: "pointer" }}
              >
                <IconResource type={showPassword ? "unlock" : "lock"} size={20} />
              </InputGroup.Text>
            </InputGroup>
          </>
        );
      case "icon":
        return (
          <>
            {props?.label ? (
              <Form.Label className={isRequired ? "is-required" : ""} aria-label={props?.label}>{props?.label}</Form.Label>
            ) : (
              ""
            )}
            <InputGroup className="mb-3">
              {props?.prefixIcon ? (
                <InputGroup.Text
                  id="basic-addon2"
                  onClick={onClickIconPre ?? null}
                >
                  <IconResource type={props?.prefixIcon} />
                </InputGroup.Text>
              ) : (
                ""
              )}
              <Form.Control
                placeholder={props?.placeholder}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                type="text"
                pattern={props?.pattern}
                {...props}
              />
              {props?.suffixIcon ? (
                <InputGroup.Text
                  id="basic-addon2"
                  onClick={onClickIconSuff ?? null}
                >
                  <IconResource
                    type={showLoaderIcon ? "loader" : props?.suffixIcon}
                  />
                </InputGroup.Text>
              ) : (
                ""
              )}
            </InputGroup>
          </>
        );
      case "currency": {
        const decimalsAllowed = props?.allowDecimals ?? props?.allowDecimal ?? false;
        const decimalsScale = props?.decimalScale ?? props?.decimalsScale ?? 2;
        const decimalsCap = props?.decimalsLimit ?? decimalsScale;
        const {
          allowDecimal: _allowDecimalIgnored,
          allowDecimals: _allowDecimalsIgnored,
          decimalScale: _decimalScaleIgnored,
          decimalsScale: _decimalsScaleIgnored,
          decimalsLimit: _decimalsLimitIgnored,
          ...restProps
        } = props ?? {};
        return <>
          {props?.label ? (<Form.Label className={isRequired ? "is-required" : ""} aria-label={props?.label}>{props?.label}</Form.Label>) : ("")}
          <InputGroup>
            <CurrencyInput
              style={{ width: "100%", marginBottom: "1rem" }}
              id={props.controlId}
              name={props.controlId}
              className="currency_input"
              placeholder={props.placeholder}
              readOnly={props.readOnly}
              allowNegativeValue={props?.allowNegativeValue ?? false}
              decimalSeparator="."
              groupSeparator=","
              allowDecimals={decimalsAllowed}
              decimalsLimit={decimalsAllowed ? decimalsCap : 0}
              decimalScale={decimalsAllowed ? decimalsScale : 0}
              defaultValue={props.defaultValue}
              value={props?.value ?? 0}
              onValueChange={!props?.onValueChange
                ? null
                : (val, _, values) => {
                  let value = val;

                  if (decimalsAllowed && typeof value === 'string') {
                    const condition = value.includes('.') && (value.length - 1) === value.indexOf('.');
                    if (condition) value += '00';
                  }

                  props?.onValueChange(value, _, values);
                }}
              onKeyDown={e => preventPlusMinusInNumberInput(e)}
              prefix={props.currencyPrefix ? (props?.currency === 'USD' ? DOLLAR : RUPEE) : null}
              intlConfig={props.currencyPrefix ? (props?.currency === 'USD' ? { locale: 'en-US', currency: 'USD' } : { locale: 'en-IN', currency: 'INR' }) : null}
              {...restProps}
            />
          </InputGroup>
        </>;
      }
      case "phone":
        return <>
          {props?.label ? (<Form.Label className={isRequired ? "is-required" : ""} aria-label={props?.label}>{props?.label}</Form.Label>) : ("")}
          <PhoneInput
            className="mb-3"
            placeholder={placeholder}
            country={country || "India"}
            value={value}
            onChange={onChange}
            disabled={disabled}
            autoFocus={autoFocus}
            defaultCountry={props?.defaultCountry || "IN"}
            limitMaxLength={14}
            {...props}
          />
        </>
      case "email":
        return (
          <>
            {props?.label ? (
              <Form.Label className={isRequired ? "is-required" : ""} aria-label={props?.label}>{props?.label}</Form.Label>
            ) : (
              ""
            )}
            <InputGroup className="mb-3">
              {props?.prefixIcon ? (
                <InputGroup.Text
                  id="basic-addon2"
                  onClick={onClickIconPre ?? null}
                >
                  <IconResource
                    type={props?.prefixIcon}
                    color={"var(--light-text)"}
                  />
                </InputGroup.Text>
              ) : (
                ""
              )}
              <Form.Control
                placeholder={props?.placeholder}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                type="email"
                required={props?.required}
                pattern={props?.pattern}
                {...props}
              />
              {props?.suffixIcon ? (
                <InputGroup.Text
                  id="basic-addon2"
                  onClick={onClickIconSuff ?? null}
                >
                  <IconResource
                    type={showLoaderIcon ? "loader" : props?.suffixIcon}
                    color={"var(--light-text)"}
                  />
                </InputGroup.Text>
              ) : (
                ""
              )}
            </InputGroup>
          </>
        );
      default:
        return (
          <>
            {props?.label ? (
              <Form.Label className={isRequired ? "is-required" : ""} aria-label={props?.label}>{props?.label}</Form.Label>
            ) : (
              ""
            )}
            <InputGroup className="mb-3">
              {props?.prefixIcon ? (
                <InputGroup.Text
                  id="basic-addon2"
                  onClick={onClickIconPre ?? null}
                >
                  <IconResource
                    type={props?.prefixIcon}
                    color={"var(--light-text)"}
                  />
                </InputGroup.Text>
              ) : (
                ""
              )}
              <Form.Control
                placeholder={props?.placeholder}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                type="text"
                required={props?.required}
                pattern={props?.pattern}
                {...props}
              />
              {props?.suffixIcon ? (
                <InputGroup.Text
                  id="basic-addon2"
                  onClick={onClickIconSuff ?? null}
                >
                  <IconResource
                    type={showLoaderIcon ? "loader" : props?.suffixIcon}
                    color={"var(--light-text)"}
                  />
                </InputGroup.Text>
              ) : (
                ""
              )}
            </InputGroup>
          </>
        );
    }
  };
  return <>{render()}</>;
};

export default Input;
